import React, { useState, useEffect } from 'react'
import { useHistory, Redirect } from 'react-router-dom'
import { Typography } from '@material-ui/core'
import axios from 'axios'
import queryString from 'query-string'

import { FaSpotify } from 'react-icons/fa'

import conf from '../../config/config'

import { useSpotify } from '../../hoc/context/SpotifyContextContainer'


function Login(props){

    const history = useHistory()

    const [ loading, setLoading ] = useState(false)
    const [ error, setError ] = useState()

    const { code, user, refreshToken, accessToken, retrievedInfo } = useSpotify()

    const params =  new URLSearchParams(props.location.search)
    const codeParam = params.get('code')

    useEffect(() => {
        if(params.get('error'))
            return setError(params.get('error'))
            
        if(codeParam && !accessToken && !refreshToken){
            setLoading(true)
            //get access token from spotify api
            const data = {
                code: codeParam,
                redirect_uri: `${conf.SPOTIFY_REDIRECT_URI}`,
                grant_type: "authorization_code"
            }
            const options = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': `Basic ${btoa(`${conf.SPOTIFY_CLIENT_ID}:${conf.SPOTIFY_CLIENT_SECRET}`)}`
                },
                json: true
            }

            axios.post(`${conf.SPOTIFY_ACCOUNT_SERVICE_URI}`, queryString.stringify(data), options)
            .then(res => {
                const accessToken = res.data.access_token
                const refreshToken = res.data.refresh_token

                retrievedInfo(codeParam, accessToken, refreshToken)            
            }).catch(e => {
                // setError(e.message)
                // setLoading(false)
            })

        }
        return () => {
        };
    }, []);

    const scope = `streaming%20user-read-private%20user-read-email%20user-read-recently-played%20playlist-read-private%20playlist-read-collaborative%20user-top-read%20playlist-modify-private%20playlist-modify-public`
    return (
        <>
            {(!accessToken && !codeParam) && 
            
            <div className="login__content">
                <h3>spotify playlist manager</h3>
                <a className="login__button" href={`${conf.SPOTIFY_AUTHORIZE_URI}?client_id=${conf.SPOTIFY_CLIENT_ID}&response_type=code&redirect_uri=${conf.SPOTIFY_REDIRECT_URI}&scope=${scope}&state=34fFs29kd09&show_dialog=true`}>
                <FaSpotify size="25"/>Connect your spotify Account</a>
            </div>

            }
            {error && <Typography variant="body1" color="primary">{error}</Typography>}
            {( accessToken && refreshToken && code) ? <Redirect to="/"/>: null}
        </>
    );
}
export default (Login);
